import { Type } from "class-transformer";
import { AuthRules } from "src/modules/sm-base/shared/AuthRules";
import { FrontendField } from "src/modules/sm-base/netgen/FrontendField";
import { GenericObjectDefinition } from "src/modules/sm-base/netgen/GenericObjectDefinition";
import { MainFrontendConfigFieldAccess } from "./MainFrontendConfigFieldAccess";
import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class MainFrontendConfig {
    customer: string;
    @Type(() => FrontendField)
    additionalUserAttributes: FrontendField[];
    @Type(() => FrontendField)
    additionalUserGroupAttributes: FrontendField[];
    @Type(() => GenericObjectDefinition)
    genericObjectDefinitions: GenericObjectDefinition[];
    @Type(() => AuthRules)
    authRules: AuthRules = new AuthRules();
    useAdminUsers = false;
    adminUsersAllowAdd = true;
    adminUsersFieldAccess: OrdinaryObject<MainFrontendConfigFieldAccess>;
    useAdminUserGroups = false;
    onlyOneGroupPerUser = false;
    useGlobalEMailTemplates = false;
    globalEmailTemplatesAllowAdd = false;
}
